export const BookingFields = {
  id: {
    fieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
  },
  center_id: {
    fieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
  },
  repetitive: {
    fieldPath: 'repetitive',
    fieldReadPath: 'repetitive',
    name: 'repetitive',
    label: 'bookings.bookings.repetitive.label',
    help: 'help.bookings.bookings.repetitive',
    showHelp: true,
    helpMode: 'tooltip',
    inputType: 'select',
    defaultValue: false,
    options: [
      { text: 'bookings.bookings.repetitive.simple.label', value: false },
      { text: 'bookings.bookings.repetitive.multiple.label', value: true },
    ],
  },
  period_id: {
    fieldPath: 'period_id',
    fieldReadPath: 'period_id',
    name: 'period_id',
    inputType: 'entity-select',
    selectLabel: 'name',
    selectValue: 'id',
    selectEntity: 'period',
    selectMultiple: false,
    label: 'bookings.bookings.period.label',
    help: 'help.bookings.bookings.period',
    showHelp: true,
    helpMode: 'tooltip',
  },
  start_date: {
    fieldPath: 'start_date',
    fieldReadPath: 'start_date',
    name: 'start_date',
    inputType: 'datepicker',
    label: 'global.start_date.label',
  },
  end_date: {
    fieldPath: 'end_date',
    fieldReadPath: 'end_date',
    name: 'end_date',
    inputType: 'datepicker',
    label: 'global.end_date.label',
  },
  start_time: {
    fieldPath: 'start_time',
    fieldReadPath: 'start_time',
    name: 'start_time',
    inputType: 'time',
    label: 'bookings.bookings.start_time.label',
    help: 'help.bookings.bookings.start_time',
    showHelp: true,
    helpMode: 'tooltip',
  },
  end_time: {
    fieldPath: 'end_time',
    fieldReadPath: 'end_time',
    name: 'end_time',
    inputType: 'time',
    label: 'bookings.bookings.end_time.label',
    help: 'help.bookings.bookings.end_time',
    showHelp: true,
    helpMode: 'tooltip',
  },
  days: {
    fieldPath: 'days',
    fieldReadPath: 'days',
    name: 'days',
    inputType: 'button-group',
    label: 'bookings.bookings.days.label',
    options: [
      { text: 'bookings.bookings.mon.label', value: 'mon' },
      { text: 'bookings.bookings.tue.label', value: 'tue' },
      { text: 'bookings.bookings.wed.label', value: 'wed' },
      { text: 'bookings.bookings.thu.label', value: 'thu' },
      { text: 'bookings.bookings.fri.label', value: 'fri' },
      { text: 'bookings.bookings.sat.label', value: 'sat' },
      { text: 'bookings.bookings.sun.label', value: 'sun' },
    ],
  },
  bank_holidays: {
    fieldPath: 'bank_holidays',
    fieldReadPath: 'bank_holidays',
    name: 'bank_holidays',
    inputType: 'switch',
    defaultValue: true,
    label: 'bookings.bookings.bank_holidays.label',
  },
  school_holidays: {
    fieldPath: 'school_holidays',
    fieldReadPath: 'school_holidays',
    name: 'school_holidays',
    inputType: 'switch',
    defaultValue: true,
    label: 'bookings.bookings.school_holidays.label',
  },
  resource_id: {
    fieldPath: 'resources',
    fieldReadPath: 'resources',
    name: 'resources',
    inputType: 'entity-select',
    selectLabel: 'name',
    selectValue: 'id',
    selectEntity: 'resource',
    selectMultiple: false,
    label: 'bookings.bookings.resources.label',
  },
  resources: {
    fieldPath: 'resources',
    fieldReadPath: 'resources',
    name: 'resources',
    inputType: 'entity-select',
    selectLabel: 'name',
    selectValue: 'id',
    selectEntity: 'resource',
    selectMultiple: true,
    label: 'bookings.bookings.resources.label',
  },
  discipline_id: {
    fieldPath: 'discipline_id',
    fieldReadPath: 'discipline_id',
    name: 'discipline_id',
    inputType: 'entity-select',
    selectLabel: 'name',
    selectValue: 'id',
    selectEntity: 'discipline',
    selectMultiple: false,
    label: 'bookings.bookings.discipline.label',
  },
  name: {
    fieldPath: 'name',
    fieldReadPath: 'name',
    name: 'name',
    inputType: 'input',
    label: 'bookings.bookings.name.label',
    help: 'help.bookings.bookings.name',
    showHelp: true,
    helpMode: 'tooltip',
  },
  comment: {
    fieldPath: 'comment',
    fieldReadPath: 'comment',
    name: 'comment',
    inputType: 'textarea',
    label: 'bookings.bookings.comment.label',
    help: 'help.bookings.bookings.comment',
    showHelp: true,
    helpMode: 'tooltip',
  },
};

export const BookingMultiplayerFields = {
  number_of_players: {
    name: 'number_of_players',
    label: 'bookings.multiplayer_bookings.number_of_players.label',
    veeValidation: true,
    rules: [],
    selectMultiple: true,
    help: 'bookings.multiplayer_bookings.number_of_players.help',
    showHelp: true,
    helpMode: 'tooltip',
    allOptions: [
      {
        text: 'global.fields.number_of_players.2.label',
        value: 2,
      },
      {
        text: 'global.fields.number_of_players.3.label',
        value: 3,
      },
      {
        text: 'global.fields.number_of_players.4.label',
        value: 4,
      },
      {
        text: 'global.fields.number_of_players.5.label',
        value: 5,
      },
      {
        text: 'global.fields.number_of_players.6.label',
        value: 6,
      },
    ],
    options: [
      {
        text: 'global.fields.number_of_players.no_player.label',
        value: null,
      },
    ],
  },
  discipline_levels: {
    fieldPath: 'discipline_levels',
    fieldReadPath: 'discipline_levels',
    name: 'discipline_levels',
    label: 'centers.disciplines.discipline_level.label',
    id: 'discipline_levels',
  },
  player_contact: {
    fieldPath: 'contact',
    fieldReadPath: 'contact',
    name: 'contact',
    inputType: 'entity-select',
    selectLabel: 'code_fullname',
    // selectValue: 'id',
    selectEntity: 'contact',
    selectMultiple: false,
    showLabel: false,
    filters: [
      {
        filterField: 'status',
        value: ['active'],
      },
      {
        filterField: 'type',
        value: ['individual'],
      },
    ],
    withTableSearch: true,
    displayConfigName: 'search',
  },
  player_status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'to_pay', label: 'global.status.to_pay' },
      { value: 'cancelled', label: 'global.fields.status.cancelled.label' },
      { value: 'confirmed', label: 'global.fields.status.confirmed.label' },
      { value: 'created', label: 'bookings.player.fields.status.created.label' },
      { value: 'proposed', label: 'bookings.player.fields.status.proposed.label' },
    ],
    valueToVariant: [
      { value: 'confirmed', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
      { value: 'to_pay', variant: 'warning' },
    ],
  },
  player_payment_status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'paid', label: 'global.status.paid' },
      { value: 'to_pay', label: 'global.status.to_pay' },
      { value: 'failed', label: 'accounting.payment.status.failed' },
      { value: 'ongoing', label: 'accounting.orders.status.payment_process.label' },
    ],
    valueToVariant: [
      { value: 'paid', variant: 'success' },
      { value: 'failed', variant: 'danger' },
      { value: 'ongoing', variant: 'warning' },
    ],
  },
  players_list: {
    name: 'players-list',
    label: 'bookings.multiplayer_bookings.players_list.label',
    showLabel: true,
  },
};
